import { initializeApp } from "firebase/app";
import { getAuth, onIdTokenChanged } from "firebase/auth";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export const tokenListener = () => {
  onIdTokenChanged(auth, async (user) => {
    const currentToken = localStorage.getItem("token");

    if (user && currentToken) {
      const newToken = await user.getIdToken();

      if (newToken !== currentToken) {
        localStorage.setItem("token", newToken);
      }
    } else {
      localStorage.removeItem("token");
    }
  });
};

export default auth;
